import React, { useState, useEffect } from 'react';
import { Table, Spinner } from "reactstrap";

import { deviceNotificationAPI } from '../services/Device';
import NotifyModal from './NotifyModal';
import TableHeader from 'components/TableHeader';
// import { askForPermissioToReceiveNotifications } from './push-notification';

const Notifications = () => {
  const [notificationModel, setNotificationModel] = useState(false);
  const [notificationDetails,setNotificationDetails] = useState(false);
  const [deviceNotificationData, setDeviceNotificationData] = useState([])
  const [loading, setLoading] = useState(false);

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
const recordsPerPage = 50;

const indexOfLastRecord = currentPage * recordsPerPage;
const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

const currentRecords = deviceNotificationData.slice(
  indexOfFirstRecord,
  indexOfLastRecord
);

const totalPages = Math.ceil(deviceNotificationData.length / recordsPerPage);

  const toggle = () => setNotificationModel(!notificationModel);

const refreshlist = () => {
  setLoading(true);
  document.getElementById("refreshbtn").className = "fas fa-sync fa-spin";
  getAllDeviceNotification();
};

const getdata = () => {
  setLoading(true);
  getAllDeviceNotification();
};


  useEffect(() => {
    getdata()
  }, [])

const getAllDeviceNotification = async () => {
  try {
    const data = await deviceNotificationAPI();
    if (data.success) {
      setDeviceNotificationData(data.data);
    } else {
      setDeviceNotificationData([]);
    }
  } catch (error) {
    console.error("Failed to load notifications:", error);
    setDeviceNotificationData([]);
  } finally {
    setLoading(false);
    const btn = document.getElementById("refreshbtn");
    if (btn) btn.className = "fas fa-sync fa-stop";
  }
};
  const showShortLocation = (value) => {
    value = "" + value;
    if (value.length > 25) {
        value = value.substr(0, 31) + "...";
    } else {
        value;
    }
    return value;
}
  const handleShow = (item) => {
    setNotificationDetails(item);
    setNotificationModel(true);
  }

  const notificationListRecords = () => {
    if (deviceNotificationData.length > 0 && !loading) {
      return currentRecords.map((item,index) => {
        return (
          
           <tr key={index}>
              <td style={{ textAlign: "left" }}>{item.prcId || "-"}</td>
              <td style={{ textAlign: "left" }}>{showShortLocation(item.token) || "-"}</td>
              <td style={{ textAlign: "left" }}>{item.platform || "-"}</td>
              <td style={{ textAlign: "left" }}>{item.appVersion || "-"}</td>
              <td style={{ textAlign: "left" }}>
                <i style={{ cursor: "pointer" }} onClick={() => {
                  handleShow(item)
                  // askForPermissioToReceiveNotifications();
                  }} className="fas fa-comment"></i>
              </td>
            </tr>
        
        )
      })
    } else {
      return (
    <>
      {loading ? (
        <tr>
          <td colSpan="5" style={{ textAlign: "center", padding: "60px 0" }}>
            <Spinner animation="border" style={{ width: "2.5rem", height: "2.5rem", color: "#525f7f" }} />
            <div style={{ marginTop: 12, color: "#6c757d", fontSize: 14 }}>Loading...</div>
          </td>
        </tr>
      ) : (
        <tr>
          <td colSpan="5" style={{ textAlign: "center", padding: "60px 0", color: "#6c757d" }}>No Record Found!</td>
        </tr>
      )}
    </>
  );
    }
  }

 return (
  <>
    <NotifyModal notificationModel={notificationModel} setNotificationModel={setNotificationModel} toggle={toggle} notifyDetails={notificationDetails} />
    
    <div style={{ display: "flex", flexDirection: "column", background: "#fff", height: "100vh", overflow: "hidden" }}>
      
      <TableHeader 
  title="Notifications" 
  onRefresh={refreshlist}
  totalCount={deviceNotificationData.length > 0 ? deviceNotificationData.length : null}
  hasMore={false}
/>

      <div style={{ overflowY: "auto", background: "#fff" }}>
        <Table striped hover responsive bordered className="align-items-center table-flush" style={{ margin: 0 }}>
          <thead className="thead-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
            <tr>
              <th scope="col" style={{ textAlign: "left" }}>Ring Id</th>
              <th scope="col" style={{ textAlign: "left" }}>Token</th>
              <th scope="col" style={{ textAlign: "left" }}>Platform</th>
              <th scope="col" style={{ textAlign: "left" }}>App Version</th>
              <th scope="col" style={{ textAlign: "left" }}>Create</th>
            </tr>
          </thead>
          <tbody>
            {notificationListRecords()}
            {deviceNotificationData.length > 50 && !loading && (
              <tr>
                <td colSpan="5" style={{ textAlign: "right", padding: "12px 16px" }}>
                  <div style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(prev => prev - 1)}
                      style={{
                        padding: "6px 14px", borderRadius: 6, border: "1px solid #dee2e6",
                        background: currentPage === 1 ? "#f8f9fa" : "#fff",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer", fontWeight: 500,
                      }}
                    >←</button>
                   <div style={{ padding: "6px 14px", borderRadius: 6, background: "#f2f0f0", color: "#0e0d0d", fontWeight: 500, fontSize: 14 }}>
  {indexOfFirstRecord + 1}–{Math.min(indexOfLastRecord, deviceNotificationData.length)} of {deviceNotificationData.length}
</div>
                    <button
                      disabled={currentPage === totalPages || totalPages === 0}
                      onClick={() => setCurrentPage(prev => prev + 1)}
                      style={{
                        padding: "6px 14px", borderRadius: 6, border: "1px solid #dee2e6",
                        background: currentPage === totalPages ? "#f8f9fa" : "#fff",
                        cursor: currentPage === totalPages ? "not-allowed" : "pointer", fontWeight: 500,
                      }}
                    >→</button>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  </>
);
}
export default Notifications;
